"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolved = exports.Rejected = exports.reject = exports.resolve = void 0;
const resolve = (value) => new Resolved(value);
exports.resolve = resolve;
const reject = (err) => new Rejected(err);
exports.reject = reject;
class Rejected {
    get isResolved() {
        return false;
    }
    get isRejected() {
        return true;
    }
    then(_f) {
        return (0, exports.reject)(this.error);
    }
    catch(f) {
        return (0, exports.reject)(f(this.error));
    }
    constructor(error) {
        this.value = undefined;
        this.error = error;
    }
}
exports.Rejected = Rejected;
class Resolved {
    get isResolved() {
        return true;
    }
    get isRejected() {
        return false;
    }
    then(f) {
        return (0, exports.resolve)(f(this.value));
    }
    catch(_f) {
        return (0, exports.resolve)(this.value);
    }
    constructor(value) {
        this.error = undefined;
        this.value = value;
    }
}
exports.Resolved = Resolved;
